import { render, staticRenderFns } from "./ActiveRecordItem.vue?vue&type=template&id=fef557c8&scoped=true&"
import script from "./ActiveRecordItem.vue?vue&type=script&lang=js&"
export * from "./ActiveRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./ActiveRecordItem.vue?vue&type=style&index=0&id=fef557c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef557c8",
  null
  
)

export default component.exports